import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/components/site/HomePage";
import HistoriePage from "@/components/site/HistoriePage";
import EnqueteUitslagPage from "@/components/site/EnqueteUitslagPage";
import UpdatesPage from "@/components/site/UpdatesPage";
import Bedankt from "@/components/site/Bedankt";
import ScrollToTop from "@/components/site/ScrollToTop";
import Analytics from "@/components/site/Analytics";

function App() {
  return (
    <div className="App font-body bg-[#FAF7F2] text-[#1A2E22] antialiased overflow-x-hidden">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/historie" element={<HistoriePage />} />
          <Route path="/enquete-uitslag" element={<EnqueteUitslagPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
          <Route path="/bedankt" element={<Bedankt />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
